import sectionMarqueeTinoCss from '../css-snippets/section-marquee-tino';

const html = `
<style>${sectionMarqueeTinoCss}</style>
<div id="card-container-unique-id" data-id="unique-id" data-attribute="card-container" data-background="#FFFFFF" data-top-padding="true" data-bottom-padding="true"
  style="background-color: rgb(255, 255, 255);">
  <div data-attribute="wrap-content" class="wrap-content">
    <div data-enable-header="true" class="section-header">
      <div data-attribute="title" class="section-title">Why is Bamboo Better?</div>
      <div data-enable-line="true" data-width="80" data-color="#90c4be" data-attribute="line-stroke" class="line-stroke"
        style="background-color: rgb(144, 196, 190); height: 2px; width: 80%; margin: 0px auto; display: block;"></div>
      <div data-attribute="description" class="section-description">Our premium bamboo material has so many benefits,
        it's hard to just pick one</div>
    </div>
    <div class="marquee-wrapper">
      <div data-attribute="list-item" class="slider-jk">
        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690172ecfbdedc7e4cbcf7f7.webp?w=300&amp;h=50&amp;q=80"
                alt="">
            </div>
            <div class="group-text" data-attribute="text-item">
              <h2 style="text-align:center;"><strong>Eco-Friendly</strong></h2>
              <p style="text-align:center;">Uses 10X less water compared to cotton</p>
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690172fb465ce7ecf1a0cfa2.webp?w=300&amp;h=50&amp;q=80"
                alt="">
            </div>
            <div class="group-text" data-attribute="text-item">
              <h2 style="text-align:center;"><strong>Organically Grown</strong></h2>
              <p style="text-align:center;">No pesticides, fertilizers or nasties</p>
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690173095763ff14b78f8e5c.webp?w=300&amp;h=50&amp;q=80"
                alt="">
            </div>
            <div class="group-text" data-attribute="text-item">
              <h2 style="text-align:center;"><strong>Anti-Bacterial</strong></h2>
              <p style="text-align:center;">Naturally breathable, and hypoallergenic</p>
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690173183c430f6bacb04179.webp?w=300&amp;h=50&amp;q=80"
                alt="">
            </div>
            <div class="group-text" data-attribute="text-item">
              <h2 style="text-align:center;"><strong>Thermo-regulating</strong></h2>
              <p style="text-align:center;">Warms you when it's cold &nbsp;and cools you when it's hot</p>
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690173241da9b6032fe1f1b2.webp?w=300&amp;h=50&amp;q=80"
                alt="">
            </div>
            <div class="group-text" data-attribute="text-item">
              <h2 style="text-align:center;"><strong>Native Freshness</strong></h2>
              <p style="text-align:center;">Prevents bad odor 4X better than cotton</p>
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-69017333c4610df832c0d2e2.webp?w=300&amp;h=50&amp;q=80"
                alt="">
            </div>
            <div class="group-text" data-attribute="text-item">
              <h2 style="text-align:center;"><strong>Superbly Soft</strong></h2>
              <p style="text-align:center;">Luxuriously soft and only gets softer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
